import clone from 'just-clone'
import { ThunkAction } from 'redux-thunk'
import { v4 } from 'uuid'
import Section, {
  calculateCornerSectionSize,
  DividerPropsType,
  SectionProps,
} from './../classes/Section'
import { searchObject } from './../common/helpers'
import { SectionLock } from './../components/Three/Three'
import { appConfig, baseLegConfig } from './../config'
import store, { InferActionsType, StateType } from './store'
import { HandleOrientationType } from '../classes/Item'

// export type CabinetPropsValue = {
//     min: number
//     value: number
//     max: number
// }

export type CabinetProps = {
  width: number //CabinetPropsValue
  height: number //CabinetPropsValue
  depth: number //CabinetPropsValue
  legHeight: number
  sectionProps: SectionProps
}

export type CornerCabinetProps = {
  type: 'angled' | '2door'
  height: number
  width1: number
  width2: number
  backWidth1: number
  backWidth2: number
  depth1: number
  depth2: number
  legHeight: number
  thickness: number
  sectionProps: SectionProps
}

export type DoorType = 'left' | 'right' | 'double' | 'liftUp'

export const newDoorVisualTypeValues: DoorNewVisualTypes[] = [
  '#B200-R203-S01',
  '#B200-R203-S04',
  '#B200-R401-S01',
  '#B200-R401-S04',
  '#B200-R500-S01',
  '#B200-R500-S04',
  '#B600-R102-S01',
  '#B600-R102-S04',
  '#B600-R100-S01',
  '#B600-R100-S04',
  '#B602-R102-S01',
  '#B602-R102-S04',
  '#B100-R000-S01',
  '#B100-R000-S04',
]
export type DoorNewVisualTypes =
  | '#B200-R203-S01'
  | '#B200-R203-S04'
  | '#B200-R401-S01'
  | '#B200-R401-S04'
  | '#B200-R500-S01'
  | '#B200-R500-S04'
  | '#B600-R102-S01'
  | '#B600-R102-S04'
  | '#B600-R100-S01'
  | '#B600-R100-S04'
  | '#B602-R102-S01'
  | '#B602-R102-S04'
  | '#B100-R000-S01'
  | '#B100-R000-S04'

export const handleTypes = {
  pull: [
    'standard',
    'arch',
    // 'DHP504-76',
    'DHP306-96',
    'DHP180-128',
    'DHP465-192',
  ],
  knob: ['DHK301', 'DHK401'],
  noPull: [],
}

export const knobHandleTypes = ['DHK301', 'DHK401']

export type DoorVisualType =
  | 'vGroove'
  | 'fivePieces'
  | DoorNewVisualTypes
  | 'shaker_v'
  | 'shaker_h'

export type HandlePositionTypes =
  | 'top'
  | 'bottom'
  | 'center'
  | 'fromGround'
  | 'forDrawer'
  | 'forDrawerCenter'

export type HandlePositionXTypes = 'left' | 'right' | 'center'

export type HandlePropsType = {
  type: 'pull' | 'knob' | 'noPull'
  subtype?:
    | 'standard'
    | 'arch'
    | 'DHP504-76'
    | 'DHP306-96'
    | 'DHP180-128'
    | 'DHP465-192'
    | 'DHK301'
    | 'DHK401'
  position: HandlePositionTypes | number
  positionX: HandlePositionXTypes | number
  orientation: HandleOrientationType
}

export type DrawerSlideType = 'standard' | 'soft' | 'under_mount'

export type ShelvesPropsType = {
  sectionNumber: number
  count: number
  sectionHeight: number
  sectionY: number
}

export type DoorPropsType = {
  type: DoorType
  uuid: string
  sectionNumber: number
  sectionHeight: number
  sectionY: number
  handleProps: HandlePropsType
  visualType: DoorVisualType
  normalMapSplitter?: string
}

export type DrawerVisualType =
  | 'standard'
  | 'fivePieces'
  | DoorNewVisualTypes
  | 'shaker_v'
  | 'shaker_h'

export type DrawerPropsType = {
  uuid: string
  sectionNumber: number
  sectionHeight: number
  sectionY: number
  handleProps: HandlePropsType
  visualType?: DrawerVisualType
}

export type LegPropsType = {
  on: boolean
  type:
    | 'standard'
    | 'standard2_1'
    | 'standard2_2'
    | 'noToeKick'
    | 'base'
    | 'baseIsland'
    | 'baseIsland2'
    | 'separateBase'
  subType?: 'cornerLeft' | 'cornerRight'
}
export type CabinetType = 'base' | 'tall' | 'upper' | 'advanced'
const clearNumber = '15'
if (localStorage.getItem('isCleared') !== clearNumber) {
  // localStorage.removeItem('itemsProps')
  // localStorage.removeItem('hardwareGridState')
  // localStorage.removeItem('materialGridState')
  // localStorage.removeItem('materialGroupGridState')
  // localStorage.removeItem('userCabinetsGridState')
  // localStorage.removeItem('categoryGridState')
  // localStorage.removeItem('usersInfoGridState')
  // localStorage.removeItem('costumerGridState')
  // localStorage.removeItem('cabinetProps')
  localStorage.removeItem('unit')
  localStorage.setItem('isCleared', clearNumber)
}

const initState = {
  props: {
    width: appConfig.startCabinetProps.width,
    height: appConfig.startCabinetProps.height,
    depth: appConfig.startCabinetProps.depth,
    legHeight: 12,
    sectionProps: {
      name: 'section',
      width: appConfig.startCabinetProps.width - 1.905 * 2,
      height: appConfig.startCabinetProps.height - 12 - 1.905 * 2,
      y: 0,
      dividersProps: appConfig.startDividers,
      doorsProps: appConfig.startDoors,
      drawersProps: appConfig.startDrawers,
      shelvesProps: appConfig.startShelves,
    },
  } as CabinetProps,
  cornerProps: {
    type: '2door',
    height: 60,
    width1: 80,
    width2: 80,
    backWidth1: 40,
    backWidth2: 40,
    depth1: 60,
    depth2: 60,
    thickness: 1.9,
    legHeight: 12,
    sectionProps: {
      name: 'section',
      width: 25.6,
      height: 56.2,
      angle: 0,
      y: 0,
      dividersProps: appConfig.startDividers,
      doorsProps: appConfig.startDoors,
      drawersProps: appConfig.startDrawers,
      shelvesProps: appConfig.startShelves,
    },
  } as CornerCabinetProps,
  section: undefined as undefined | Section,
  doorType: (localStorage.getItem('doorType') || 'left') as DoorType,
  doorVisualType: (localStorage.getItem('doorVisualType') ||
    'vGroove') as DoorVisualType,
  panelVisualType: (localStorage.getItem('panelVisualType') ||
    'vGroove') as DoorVisualType,
  handleProps: {
    type: 'pull',
    subtype: 'standard',
    position: 'center',
    positionX: 'left',
    orientation: 'vertical',
  } as HandlePropsType,
  drawerSlideType: 'standard' as DrawerSlideType,
  isFrontPanelsVisible: true,
  viewSectionHeight: false,
  legProps: localStorage.getItem('legProps')
    ? (JSON.parse(localStorage.getItem('legProps') || '') as LegPropsType)
    : ({
        on: true,
        type: 'standard',
      } as LegPropsType),
  baseLegCut: baseLegConfig.cutLength,
  splittedTop: localStorage.getItem('splittedTop')
    ? (JSON.parse(localStorage.getItem('splittedTop') || '') as boolean)
    : true,
  cabinetType: (localStorage.getItem('cabinetType') || 'base') as CabinetType,
  isAddingDivider: false,
  isChangingHeight: false,
  isCorner: false,
}

type InitStateType = typeof initState

const cabinetReducer = (
  state = initState,
  action: ActionsType
): InitStateType => {
  switch (action.type) {
    case 'cc/cabinet/SET_CABINET': {
      return {
        ...state,
        isCorner: false,
        cabinetType: action.cabinetType,
        legProps: action.legProps,
        baseLegCut: action.baseLegCut,
        splittedTop: action.splittedTop,
        props: {
          width: action.width,
          height: action.height,
          depth: action.depth,
          legHeight: action.legHeight,
          sectionProps: {
            name: 'section',
            width: action.width - action.thickness * 2,
            height: action.height - action.thickness * 2,
            y: 0,
            dividersProps: action.dividerProps,
            doorsProps: action.doorsProps,
            drawersProps: action.drawersProps,
            shelvesProps: action.shelvesProps,
          },
        },
      }
    }
    case 'cc/cabinet/SET_PROPS':
      return {
        ...state,
        props: { ...action.props },
      }
    case 'cc/cabinet/SET_WIDTH':
      return {
        ...state,
        props: {
          ...state.props,
          width: action.value,
          sectionProps: {
            ...state.props.sectionProps,
            width: action.value - action.thickness * 2,
          },
        },
      }
    case 'cc/cabinet/SET_HEIGHT': {
      const height = action.fromUI
        ? action.value - state.props.legHeight
        : action.value
      return {
        ...state,
        props: {
          ...state.props,
          height,
          sectionProps: {
            ...state.props.sectionProps,
            height: height - action.thickness * 2,
          },
        },
        isChangingHeight: true,
      }
    }
    case 'cc/cabinet/SET_DEPTH':
      return {
        ...state,
        props: { ...state.props, depth: action.value },
      }
    case 'cc/cabinet/SET_SECTION_PROPS':
      return {
        ...state,
        props: { ...state.props, sectionProps: action.prop },
      }
    case 'cc/cabinet/SET_SECTION':
      return {
        ...state,
        section: { ...action.section },
      }
    case 'cc/cabinet/SET_DIVIDER': {
      const sectionProps = state.props.sectionProps

      // console.log(JSON.stringify(sectionProps))
      const res = searchObject(
        sectionProps,
        (val) => (<SectionProps>val).name === action.sectionName
      )

      if (res) {
        // (<SectionProps>res[0].value).dividerProps = action.dividerProps
      }
      //
      // setDriver(sectionProps, action.sectionName, action.dividerProps)

      // console.log(JSON.stringify(sectionProps))

      // debugger
      // if (sectionProps.name === action.sectionName) {
      //     sectionProps.dividerProps = action.dividerProps
      // }
      // else {

      //     let subSectionProps = sectionProps

      //     while (
      //         sectionProps.dividerProps &&
      //         (sectionProps.dividerProps.sections.s1.name !== action.sectionName  )
      //     ) {

      //     }
      // }

      return {
        ...state,
        props: {
          ...state.props,
          sectionProps: { ...sectionProps },
        },
      }
    }
    case 'cc/cabinet/ADD_DIVIDERS':
      return !state.isCorner
        ? {
            ...state,
            props: {
              ...state.props,
              sectionProps: {
                ...state.props.sectionProps,
                dividersProps: [
                  ...state.props.sectionProps.dividersProps,
                  ...action.arr,
                ],
              },
            },
            isAddingDivider: true,
          }
        : {
            ...state,
            cornerProps: {
              ...state.cornerProps,
              sectionProps: {
                ...state.cornerProps.sectionProps,
                dividersProps: [
                  ...state.cornerProps.sectionProps.dividersProps,
                  ...action.arr,
                ],
              },
            },
            isAddingDivider: true,
          }
    case 'cc/cabinet/DELETE_DIVIDER': {
      const sectionProps = !state.isCorner
        ? state.props.sectionProps
        : state.cornerProps.sectionProps
      let dividersProps = clone(sectionProps.dividersProps).sort(
        (a, b) => a.top - b.top
      )

      const dividerNumber = parseInt(action.dividerName.split('_')[1])

      //change panels and shelves
      const newShelves = clone(sectionProps.shelvesProps)
        .filter(
          (shProps) =>
            shProps.sectionNumber !== dividerNumber &&
            shProps.sectionNumber !== dividerNumber + 1
        )
        .map((dProps) => {
          if (dProps.sectionNumber > dividerNumber) {
            dProps.sectionNumber--
          }
          return dProps
        })

      const newDoors = clone(sectionProps.doorsProps)
        .filter(
          (dProps) =>
            dProps.sectionNumber !== dividerNumber &&
            dProps.sectionNumber !== dividerNumber + 1
        )
        .map((dProps) => {
          if (dProps.sectionNumber > dividerNumber) {
            dProps.sectionNumber--
          }
          return dProps
        })

      const newDrawers = clone(sectionProps.drawersProps)
        .filter(
          (dProps) =>
            dProps.sectionNumber !== dividerNumber &&
            dProps.sectionNumber !== dividerNumber + 1
        )
        .map((dProps) => {
          if (dProps.sectionNumber > dividerNumber) {
            dProps.sectionNumber--
          }
          return dProps
        })

      return !state.isCorner
        ? {
            ...state,
            props: {
              ...state.props,
              sectionProps: {
                ...state.props.sectionProps,
                dividersProps: dividersProps.filter(
                  (value, i) => i !== dividerNumber - 1
                ),
                doorsProps: newDoors,
                drawersProps: newDrawers,
                shelvesProps: newShelves,
              },
            },
          }
        : {
            ...state,
            cornerProps: {
              ...state.cornerProps,
              sectionProps: {
                ...state.cornerProps.sectionProps,
                dividersProps: dividersProps.filter(
                  (value, i) => i !== dividerNumber - 1
                ),
                doorsProps: newDoors,
                drawersProps: newDrawers,
                shelvesProps: newShelves,
              },
            },
          }
    }
    case 'cc/cabinet/SET_DIVIDERS':
      return !state.isCorner
        ? {
            ...state,
            props: {
              ...state.props,
              sectionProps: {
                ...state.props.sectionProps,
                dividersProps: [...action.arr],
              },
            },
          }
        : {
            ...state,
            cornerProps: {
              ...state.cornerProps,
              sectionProps: {
                ...state.cornerProps.sectionProps,
                dividersProps: [...action.arr],
              },
            },
          }
    case 'cc/cabinet/SET_DOOR_TYPE':
      return !state.isCorner
        ? {
            ...state,
            doorType: action.newType,
            props: {
              ...state.props,
              sectionProps: {
                ...state.props.sectionProps,
                doorsProps: state.props.sectionProps.doorsProps.map(
                  (doorProps) => {
                    doorProps.type = action.newType

                    if (action.newType === 'liftUp') {
                      doorProps.handleProps.position = 'bottom'
                    }

                    doorProps.handleProps.positionX =
                      action.newType === 'liftUp'
                        ? 'center'
                        : action.newType === 'left'
                        ? 'right'
                        : 'left'

                    return doorProps
                  }
                ),
              },
            },
          }
        : {
            ...state,
            doorType: action.newType,
            cornerProps: {
              ...state.cornerProps,
              sectionProps: {
                ...state.cornerProps.sectionProps,
                doorsProps: state.cornerProps.sectionProps.doorsProps.map(
                  (doorProps) => {
                    doorProps.type = action.newType

                    if (action.newType === 'liftUp') {
                      doorProps.handleProps.position = 'bottom'
                    }

                    doorProps.handleProps.positionX =
                      action.newType === 'liftUp'
                        ? 'center'
                        : action.newType === 'left'
                        ? 'right'
                        : 'left'

                    return doorProps
                  }
                ),
              },
            },
          }
    case 'cc/cabinet/SET_SECTION_DOOR': {
      const sectionProps = !state.isCorner
        ? state.props.sectionProps
        : state.cornerProps.sectionProps

      let newDoorProps = clone(sectionProps.doorsProps)
      let newDrawerProps = clone(sectionProps.drawersProps)

      //delete drawer
      newDrawerProps = newDrawerProps.filter(
        (drawer) => drawer.sectionNumber !== action.sectionNumber
      )

      if (
        newDoorProps.filter(
          (doorProps) => doorProps.sectionNumber === action.sectionNumber
        ).length
      ) {
        if (action.door) {
          newDoorProps = newDoorProps.map((doorProps) => {
            if (doorProps.sectionNumber === action.sectionNumber) {
              doorProps = { ...action.door } as DoorPropsType
              return doorProps
            } else return doorProps
          })
        } else {
          newDoorProps = newDoorProps.filter(
            (doorProps) => doorProps.sectionNumber !== action.sectionNumber
          )
        }
      } else if (action.door) {
        newDoorProps = [...newDoorProps, action.door]
      }

      return !state.isCorner
        ? {
            ...state,
            props: {
              ...state.props,
              sectionProps: {
                ...state.props.sectionProps,
                doorsProps: newDoorProps,
                drawersProps: newDrawerProps,
              },
            },
          }
        : {
            ...state,
            cornerProps: {
              ...state.cornerProps,
              sectionProps: {
                ...state.cornerProps.sectionProps,
                doorsProps: newDoorProps,
                drawersProps: newDrawerProps,
              },
            },
          }
    }
    case 'cc/cabinet/SET_SECTION_DRAWER': {
      let newDoorProps = clone(state.props.sectionProps.doorsProps)
      let newDrawerProps = clone(state.props.sectionProps.drawersProps)
      let newShelvesProps = clone(state.props.sectionProps.shelvesProps)

      //delete door and shelves
      newDoorProps = newDoorProps.filter(
        (door) => door.sectionNumber !== action.sectionNumber
      )
      newShelvesProps = newShelvesProps.filter(
        (shelf) => shelf.sectionNumber !== action.sectionNumber
      )

      if (
        newDrawerProps.filter(
          (drawerProps) => drawerProps.sectionNumber === action.sectionNumber
        ).length
      ) {
        if (action.drawer) {
          newDrawerProps = newDrawerProps.map((drawerProps) => {
            if (drawerProps.sectionNumber === action.sectionNumber) {
              drawerProps = { ...action.drawer } as DrawerPropsType
              return drawerProps
            } else return drawerProps
          })
        } else {
          newDrawerProps = newDrawerProps.filter(
            (drawerProps) => drawerProps.sectionNumber !== action.sectionNumber
          )
        }
      } else if (action.drawer) {
        newDrawerProps = [...newDrawerProps, action.drawer]
      }

      return {
        ...state,
        props: {
          ...state.props,
          sectionProps: {
            ...state.props.sectionProps,
            doorsProps: newDoorProps,
            drawersProps: newDrawerProps,
            shelvesProps: newShelvesProps,
          },
        },
      }
    }
    case 'cc/cabinet/SET_SECTION_SHELVES': {
      const sectionProps = !state.isCorner
        ? state.props.sectionProps
        : state.cornerProps.sectionProps
      let newShelvesProps = clone(sectionProps.shelvesProps)
      let newDrawerProps = clone(sectionProps.drawersProps)

      //delete drawer
      newDrawerProps = newDrawerProps.filter(
        (drawer) => drawer.sectionNumber !== action.sectionNumber
      )

      if (
        newShelvesProps.filter(
          (shelvesProps) => shelvesProps.sectionNumber === action.sectionNumber
        ).length
      ) {
        if (action.shelves) {
          newShelvesProps = newShelvesProps.map((shelvesProps) => {
            if (shelvesProps.sectionNumber === action.sectionNumber) {
              shelvesProps = { ...action.shelves } as ShelvesPropsType
              return shelvesProps
            } else return shelvesProps
          })
        } else {
          newShelvesProps = newShelvesProps.filter(
            (shelvesProps) =>
              shelvesProps.sectionNumber !== action.sectionNumber
          )
        }
      } else if (action.shelves) {
        newShelvesProps = [...newShelvesProps, action.shelves]
      }

      return !state.isCorner
        ? {
            ...state,
            props: {
              ...state.props,
              sectionProps: {
                ...state.props.sectionProps,
                shelvesProps: newShelvesProps,
                drawersProps: newDrawerProps,
              },
            },
          }
        : {
            ...state,
            cornerProps: {
              ...state.cornerProps,
              sectionProps: {
                ...state.cornerProps.sectionProps,
                shelvesProps: newShelvesProps,
                drawersProps: newDrawerProps,
              },
            },
          }
    }
    case 'cc/cabinet/SET_DOORS':
      return !state.isCorner
        ? {
            ...state,
            props: {
              ...state.props,
              sectionProps: {
                ...state.props.sectionProps,
                doorsProps: [...action.arr],
              },
            },
          }
        : {
            ...state,
            cornerProps: {
              ...state.cornerProps,
              sectionProps: {
                ...state.cornerProps.sectionProps,
                doorsProps: [...action.arr],
              },
            },
          }
    case 'cc/cabinet/SET_DRAWERS':
      return {
        ...state,
        props: {
          ...state.props,
          sectionProps: {
            ...state.props.sectionProps,
            drawersProps: [...action.arr],
          },
        },
      }
    case 'cc/cabinet/SET_SHELVES':
      return !state.isCorner
        ? {
            ...state,
            props: {
              ...state.props,
              sectionProps: {
                ...state.props.sectionProps,
                shelvesProps: [...action.arr],
              },
            },
          }
        : {
            ...state,
            cornerProps: {
              ...state.cornerProps,
              sectionProps: {
                ...state.cornerProps.sectionProps,
                shelvesProps: [...action.arr],
              },
            },
          }
    case 'cc/cabinet/SET_IS_FRONT_PANELS_VISIBLE':
      return {
        ...state,
        isFrontPanelsVisible: action.value,
      }
    case 'cc/cabinet/SET_HANDLE_POSITION':
      return {
        ...state,
        handleProps: { ...state.handleProps, position: action.newPos },
        props: {
          ...state.props,
          sectionProps: {
            ...state.props.sectionProps,
            doorsProps: state.props.sectionProps.doorsProps.map((doorProps) => {
              doorProps.handleProps.position = action.newPos
              return doorProps
            }),
          },
        },
      }
    case 'cc/cabinet/SET_HANDLE_VISUAL_TYPE':
      // return {
      //     ...state,
      //     handleProps: { ...state.handleProps, type: action.newType },
      //     props: {
      //         ...state.props,
      //         sectionProps: {
      //             ...state.props.sectionProps,
      //             doorsProps: state.props.sectionProps.doorsProps.map(doorProps => {
      //                 doorProps.handleProps.type = action.newType
      //                 return doorProps
      //             }),
      //             drawersProps: state.props.sectionProps.drawersProps.map(drawerProps => {
      //                 drawerProps.handleProps.type = action.newType
      //                 return drawerProps
      //             }),
      //         }
      //     }
      // }
      return !state.isCorner
        ? {
            ...state,
            handleProps: { ...state.handleProps, type: action.newType },
            props: {
              ...state.props,
              sectionProps: {
                ...state.props.sectionProps,
                doorsProps: state.props.sectionProps.doorsProps.map(
                  (doorProps) => {
                    doorProps.handleProps.type = action.newType
                    return doorProps
                  }
                ),
                drawersProps: state.props.sectionProps.drawersProps.map(
                  (drawerProps) => {
                    drawerProps.handleProps.type = action.newType
                    return drawerProps
                  }
                ),
              },
            },
          }
        : {
            ...state,
            handleProps: { ...state.handleProps, type: action.newType },
            cornerProps: {
              ...state.cornerProps,
              sectionProps: {
                ...state.cornerProps.sectionProps,
                doorsProps: state.cornerProps.sectionProps.doorsProps.map(
                  (doorProps) => {
                    doorProps.handleProps.type = action.newType
                    return doorProps
                  }
                ),
                drawersProps: state.cornerProps.sectionProps.drawersProps.map(
                  (drawerProps) => {
                    drawerProps.handleProps.type = action.newType
                    return drawerProps
                  }
                ),
              },
            },
          }
    case 'cc/cabinet/SET_HANDLE_SUB_TYPE':
      return !state.isCorner
        ? {
            ...state,
            handleProps: { ...state.handleProps, subtype: action.newType },
            props: {
              ...state.props,
              sectionProps: {
                ...state.props.sectionProps,
                doorsProps: state.props.sectionProps.doorsProps.map(
                  (doorProps) => {
                    doorProps.handleProps.subtype = action.newType
                    return doorProps
                  }
                ),
                drawersProps: state.props.sectionProps.drawersProps.map(
                  (drawerProps) => {
                    drawerProps.handleProps.subtype = action.newType
                    return drawerProps
                  }
                ),
              },
            },
          }
        : {
            ...state,
            handleProps: { ...state.handleProps, subtype: action.newType },
            cornerProps: {
              ...state.cornerProps,
              sectionProps: {
                ...state.cornerProps.sectionProps,
                doorsProps: state.cornerProps.sectionProps.doorsProps.map(
                  (doorProps) => {
                    doorProps.handleProps.subtype = action.newType
                    return doorProps
                  }
                ),
                drawersProps: state.cornerProps.sectionProps.drawersProps.map(
                  (drawerProps) => {
                    drawerProps.handleProps.subtype = action.newType
                    return drawerProps
                  }
                ),
              },
            },
          }
    case 'cc/cabinet/SET_VIEW_SECTION_HEIGHT':
      return {
        ...state,
        viewSectionHeight: action.value,
      }
    case 'cc/cabinet/SET_LEGS_ON':
      return {
        ...state,
        legProps: {
          ...state.legProps,
          on: action.value,
        },
      }
    case 'cc/cabinet/SET_SPLITTED_TOP':
      return {
        ...state,
        splittedTop: action.value,
      }
    case 'cc/cabinet/SET_CABINET_TYPE': {
      let isSplitted = state.splittedTop
      let isLegs = state.legProps.on

      if (action.value === 'base') {
        isSplitted = true
        isLegs = true
      } else if (action.value === 'tall') {
        isSplitted = false
        isLegs = true
      } else if (action.value === 'upper') {
        isSplitted = false
        isLegs = false
      }

      return !state.isCorner
        ? {
            ...state,
            cabinetType: action.value,
            splittedTop: isSplitted,
            legProps: {
              ...state.legProps,
              on: isLegs,
            },
            props: {
              ...state.props,
              legHeight: action.value === 'upper' ? 0 : 12,
            },
          }
        : {
            ...state,
            cabinetType: action.value,
            splittedTop: isSplitted,
            legProps: {
              ...state.legProps,
              on: isLegs,
            },
            cornerProps: {
              ...state.cornerProps,
              legHeight: action.value === 'upper' ? 0 : 12,
            },
          }
    }
    case 'cc/cabinet/SET_DOOR_VISUAL_TYPE':
      return {
        ...state,
        doorVisualType: action.newType,
        props: {
          ...state.props,
          sectionProps: {
            ...state.props.sectionProps,
            doorsProps: state.props.sectionProps.doorsProps.map((d) => ({
              ...d,
              visualType: action.newType,
              uuid: v4(),
            })),
          },
        },
      }
    case 'cc/cabinet/SET_PANEL_VISUAL_TYPE':
      if (state.isCorner)
        return {
          ...state,
          panelVisualType: action.newType,
          cornerProps: {
            ...state.cornerProps,
            sectionProps: {
              ...state.cornerProps.sectionProps,
              doorsProps: state.cornerProps.sectionProps.doorsProps.map(
                (d) => ({
                  ...d,
                  visualType: action.newType,
                  uuid: v4(),
                })
              ),
              drawersProps: state.cornerProps.sectionProps.drawersProps.map(
                (d) => ({
                  ...d,
                  visualType:
                    action.newType === 'vGroove' ? 'standard' : action.newType,
                  uuid: v4(),
                })
              ),
            },
          },
        }

      return {
        ...state,
        panelVisualType: action.newType,
        props: {
          ...state.props,
          sectionProps: {
            ...state.props.sectionProps,
            doorsProps: state.props.sectionProps.doorsProps.map((d) => ({
              ...d,
              visualType: action.newType,
              uuid: v4(),
            })),
            drawersProps: state.props.sectionProps.drawersProps.map((d) => ({
              ...d,
              visualType:
                action.newType === 'vGroove' ? 'standard' : action.newType,
              uuid: v4(),
            })),
          },
        },
      }
    case 'cc/cabinet/SET_LEG_TYPE':
      return {
        ...state,
        legProps: {
          ...state.legProps,
          type: action.value,
        },
      }
    case 'cc/cabinet/SET_LEG_HEIGHT': {
      const cabHeight = !state.isCorner
        ? state.props.legHeight + state.props.height
        : state.cornerProps.legHeight + state.cornerProps.height

      return !state.isCorner
        ? {
            ...state,
            props: {
              ...state.props,
              legHeight: action.value,
              height: cabHeight - action.value,
              sectionProps: {
                ...state.props.sectionProps,
                height: cabHeight - action.value - action.thickness * 2,
              },
            },
            isChangingHeight: true,
          }
        : {
            ...state,
            cornerProps: {
              ...state.cornerProps,
              legHeight: action.value,
              height: cabHeight - action.value,
              sectionProps: {
                ...state.cornerProps.sectionProps,
                height: cabHeight - action.value - action.thickness * 2,
              },
            },
            isChangingHeight: true,
          }
    }
    case 'cc/cabinet/SET_IS_ADDING_DIVIDER':
      return {
        ...state,
        isAddingDivider: action.value,
      }
    case 'cc/cabinet/SET_IS_CHANGING_HEIGHT':
      return {
        ...state,
        isChangingHeight: action.value,
      }
    case 'cc/cabinet/SET_IS_CORNER':
      return {
        ...state,
        isCorner: action.value,
      }
    case 'cc/cabinet/SET_CORNER_TYPE':
      return {
        ...state,
        cornerProps:
          action.value === '2door'
            ? {
                ...state.cornerProps,
                type: action.value,
              }
            : {
                ...state.cornerProps,
                type: action.value,
                width2: state.cornerProps.width1,
                backWidth2: state.cornerProps.backWidth1,
                depth2: state.cornerProps.depth1,
              },
      }
    case 'cc/cabinet/SET_CORNER_CABINET': {
      const sectionWidth = calculateCornerSectionSize(
        action.width1,
        action.width2,
        action.depth1,
        action.depth2,
        action.thickness
      )

      return {
        ...state,
        isCorner: true,
        cabinetType: action.cabinetType,
        legProps: action.legProps,
        baseLegCut: action.baseLegCut,
        splittedTop: action.splittedTop,
        cornerProps: {
          type: action.subType,
          height: action.height,
          width1: action.width1,
          width2: action.width2,
          depth1: action.depth1,
          depth2: action.depth2,
          backWidth1: action.backWidth1,
          backWidth2: action.backWidth2,
          legHeight: action.legHeight,
          thickness: action.thickness,
          sectionProps: {
            name: 'section',
            width: sectionWidth,
            height: action.height - action.thickness * 2,
            y: 0,
            dividersProps: action.dividerProps,
            doorsProps: action.doorsProps,
            drawersProps: action.drawersProps,
            shelvesProps: action.shelvesProps,
          },
        },
      }
    }
    case 'cc/cabinet/SET_C_HEIGHT': {
      const height = action.fromUI
        ? action.value - state.cornerProps.legHeight
        : action.value
      return {
        ...state,
        cornerProps: {
          ...state.cornerProps,
          height,
          sectionProps: {
            ...state.cornerProps.sectionProps,
            height: height - action.thickness * 2,
          },
        },
        isChangingHeight: true,
      }
    }
    case 'cc/cabinet/SET_C_WIDTH1': {
      const isAngled = state.cornerProps.type === 'angled'

      const width1 = action.value
      const width2 = isAngled ? action.value : state.cornerProps.width2

      const width = calculateCornerSectionSize(
        width1,
        width2,
        state.cornerProps.depth1,
        state.cornerProps.depth2,
        state.cornerProps.thickness
      )

      const newProps = {
        ...state.cornerProps,
        width1,
        width2,
        sectionProps: {
          ...state.cornerProps.sectionProps,
          width,
        },
      }

      return {
        ...state,
        cornerProps: newProps,
      }
    }
    case 'cc/cabinet/SET_C_WIDTH2': {
      const width2 = action.value

      const width = calculateCornerSectionSize(
        state.cornerProps.width1,
        width2,
        state.cornerProps.depth1,
        state.cornerProps.depth2,
        state.cornerProps.thickness
      )

      return {
        ...state,
        cornerProps: {
          ...state.cornerProps,
          width2,
          sectionProps: {
            ...state.cornerProps.sectionProps,
            width,
          },
        },
      }
    }
    case 'cc/cabinet/SET_C_DEPTH1': {
      const isAngled = state.cornerProps.type === 'angled'

      const depth1 = action.value
      const depth2 = isAngled ? action.value : state.cornerProps.depth2

      const width = calculateCornerSectionSize(
        state.cornerProps.width1,
        state.cornerProps.width2,
        depth1,
        depth2,
        state.cornerProps.thickness
      )

      const newProps = {
        ...state.cornerProps,
        depth1,
        depth2,
        sectionProps: {
          ...state.cornerProps.sectionProps,
          width,
        },
      }

      return {
        ...state,
        cornerProps: newProps,
      }
    }
    case 'cc/cabinet/SET_C_DEPTH2':
      const depth2 = action.value

      const width = calculateCornerSectionSize(
        state.cornerProps.width1,
        state.cornerProps.width2,
        state.cornerProps.depth1,
        depth2,
        state.cornerProps.thickness
      )

      return {
        ...state,
        cornerProps: {
          ...state.cornerProps,
          depth2,
          sectionProps: {
            ...state.cornerProps.sectionProps,
            width,
          },
        },
      }
    case 'cc/cabinet/SET_C_BACK_WIDTH1': {
      const isAngled = state.cornerProps.type === 'angled'
      return {
        ...state,
        cornerProps: isAngled
          ? {
              ...state.cornerProps,
              backWidth1: action.value,
              backWidth2: action.value,
            }
          : {
              ...state.cornerProps,
              backWidth1: action.value,
            },
      }
    }
    case 'cc/cabinet/SET_C_BACK_WIDTH2':
      return {
        ...state,
        cornerProps: {
          ...state.cornerProps,
          backWidth2: action.value,
        },
      }
    case 'cc/cabinet/SET_BASE_LEG_CUT':
      return {
        ...state,
        baseLegCut: action.value,
      }
    case 'cc/cabinet/SET_DRAWER_SLIDE_TYPE':
      return {
        ...state,
        drawerSlideType: action.value,
      }
    default:
      return state
  }
}

export const actions = {
  setCabinet: (
    width: number,
    height: number,
    depth: number,
    legHeight: number,
    cabinetType: CabinetType,
    splittedTop: boolean,
    legProps: LegPropsType,
    baseLegCut: number,
    dividerProps: DividerPropsType[],
    doorsProps: DoorPropsType[],
    drawersProps: DrawerPropsType[],
    shelvesProps: ShelvesPropsType[],
    thickness: number
  ) =>
    ({
      type: 'cc/cabinet/SET_CABINET',
      width,
      height,
      depth,
      legHeight,
      cabinetType,
      splittedTop,
      legProps,
      baseLegCut,
      dividerProps,
      doorsProps,
      drawersProps,
      shelvesProps,
      thickness,
    } as const),
  setCornerCabinet: (
    type: CornerCabinetProps['type'],
    height: number,
    width1: number,
    width2: number,
    depth1: number,
    depth2: number,
    backWidth1: number,
    backWidth2: number,
    legHeight: number,
    cabinetType: CabinetType,
    splittedTop: boolean,
    legProps: LegPropsType,
    baseLegCut: number,
    dividerProps: DividerPropsType[],
    doorsProps: DoorPropsType[],
    drawersProps: DrawerPropsType[],
    shelvesProps: ShelvesPropsType[],
    thickness: number
  ) =>
    ({
      type: 'cc/cabinet/SET_CORNER_CABINET',
      subType: type,
      height,
      width1,
      width2,
      depth1,
      depth2,
      backWidth1,
      backWidth2,
      legHeight,
      cabinetType,
      splittedTop,
      legProps,
      baseLegCut,
      dividerProps,
      doorsProps,
      drawersProps,
      shelvesProps,
      thickness,
    } as const),
  setProps: (props: CabinetProps) =>
    ({ type: 'cc/cabinet/SET_PROPS', props } as const),
  setWidth: (value: number, thickness: number) =>
    ({ type: 'cc/cabinet/SET_WIDTH', value, thickness } as const),
  setHeight: (value: number, thickness: number, fromUI: boolean) =>
    ({ type: 'cc/cabinet/SET_HEIGHT', value, thickness, fromUI } as const),
  setDepth: (value: number) =>
    ({ type: 'cc/cabinet/SET_DEPTH', value } as const),
  setSectionProps: (prop: SectionProps) =>
    ({ type: 'cc/cabinet/SET_SECTION_PROPS', prop } as const),
  setSection: (section: Section) =>
    ({ type: 'cc/cabinet/SET_SECTION', section } as const),
  setDivider: (sectionName: string, dividerProps: DividerPropsType) =>
    ({ type: 'cc/cabinet/SET_DIVIDER', sectionName, dividerProps } as const),
  setDividers: (arr: DividerPropsType[]) =>
    ({ type: 'cc/cabinet/SET_DIVIDERS', arr } as const),
  addDividers: (arr: DividerPropsType[]) =>
    ({ type: 'cc/cabinet/ADD_DIVIDERS', arr } as const),
  deleteDivider: (dividerName: string) =>
    ({ type: 'cc/cabinet/DELETE_DIVIDER', dividerName } as const),
  setDoorType: (newType: DoorType) =>
    ({ type: 'cc/cabinet/SET_DOOR_TYPE', newType } as const),
  setDoorVisualType: (newType: DoorVisualType) =>
    ({ type: 'cc/cabinet/SET_DOOR_VISUAL_TYPE', newType } as const),
  setPanelVisualType: (newType: DoorVisualType) =>
    ({ type: 'cc/cabinet/SET_PANEL_VISUAL_TYPE', newType } as const),
  setSectionDoor: (sectionNumber: number, door?: DoorPropsType) =>
    ({ type: 'cc/cabinet/SET_SECTION_DOOR', sectionNumber, door } as const),
  setSectionDrawer: (sectionNumber: number, drawer?: DrawerPropsType) =>
    ({ type: 'cc/cabinet/SET_SECTION_DRAWER', sectionNumber, drawer } as const),
  setSectionShelves: (sectionNumber: number, shelves?: ShelvesPropsType) =>
    ({
      type: 'cc/cabinet/SET_SECTION_SHELVES',
      sectionNumber,
      shelves,
    } as const),
  setDoors: (arr: DoorPropsType[], hint: string) =>
    ({ type: 'cc/cabinet/SET_DOORS', hint, arr } as const),
  setDrawers: (arr: DrawerPropsType[]) =>
    ({ type: 'cc/cabinet/SET_DRAWERS', arr } as const),
  setShelves: (arr: ShelvesPropsType[]) =>
    ({ type: 'cc/cabinet/SET_SHELVES', arr } as const),
  setIsFrontPanelsVisible: (value: boolean) =>
    ({ type: 'cc/cabinet/SET_IS_FRONT_PANELS_VISIBLE', value } as const),
  setHandlePosition: (newPos: HandlePropsType['position']) =>
    ({ type: 'cc/cabinet/SET_HANDLE_POSITION', newPos } as const),
  setHandleVisualType: (newType: HandlePropsType['type']) =>
    ({ type: 'cc/cabinet/SET_HANDLE_VISUAL_TYPE', newType } as const),
  setHandleSubType: (newType: HandlePropsType['subtype']) =>
    ({ type: 'cc/cabinet/SET_HANDLE_SUB_TYPE', newType } as const),
  setViewSectionHeight: (value: boolean) =>
    ({ type: 'cc/cabinet/SET_VIEW_SECTION_HEIGHT', value } as const),
  setLegsOn: (value: boolean) =>
    ({ type: 'cc/cabinet/SET_LEGS_ON', value } as const),
  setLegType: (value: LegPropsType['type']) =>
    ({ type: 'cc/cabinet/SET_LEG_TYPE', value } as const),
  setSplittedTop: (value: boolean) =>
    ({ type: 'cc/cabinet/SET_SPLITTED_TOP', value } as const),
  setCabinetType: (value: CabinetType) =>
    ({ type: 'cc/cabinet/SET_CABINET_TYPE', value } as const),
  setLegHeight: (value: number, thickness: number) =>
    ({ type: 'cc/cabinet/SET_LEG_HEIGHT', value, thickness } as const),
  setIsAddingDivider: (value: boolean) =>
    ({ type: 'cc/cabinet/SET_IS_ADDING_DIVIDER', value } as const),
  setIsChangingHeight: (value: boolean) =>
    ({ type: 'cc/cabinet/SET_IS_CHANGING_HEIGHT', value } as const),
  setIsCorner: (value: boolean) =>
    ({ type: 'cc/cabinet/SET_IS_CORNER', value } as const),
  setCornerType: (value: CornerCabinetProps['type']) =>
    ({ type: 'cc/cabinet/SET_CORNER_TYPE', value } as const),
  setCHeight: (value: number, thickness: number, fromUI: boolean) =>
    ({ type: 'cc/cabinet/SET_C_HEIGHT', value, thickness, fromUI } as const),
  setCWidth1: (value: number) =>
    ({ type: 'cc/cabinet/SET_C_WIDTH1', value } as const),
  setCWidth2: (value: number) =>
    ({ type: 'cc/cabinet/SET_C_WIDTH2', value } as const),
  setCDepth1: (value: number) =>
    ({ type: 'cc/cabinet/SET_C_DEPTH1', value } as const),
  setCDepth2: (value: number) =>
    ({ type: 'cc/cabinet/SET_C_DEPTH2', value } as const),
  setCBackWidth1: (value: number) =>
    ({ type: 'cc/cabinet/SET_C_BACK_WIDTH1', value } as const),
  setCBackWidth2: (value: number) =>
    ({ type: 'cc/cabinet/SET_C_BACK_WIDTH2', value } as const),
  setBaseLegCut: (value: number) =>
    ({ type: 'cc/cabinet/SET_BASE_LEG_CUT', value } as const),
  setDrawerSlideType: (value: DrawerSlideType) =>
    ({ type: 'cc/cabinet/SET_DRAWER_SLIDE_TYPE', value } as const),
}

export const recalculateAllShelvesAndDoorsPositions = (
  actualDividers: DividerPropsType[],
  cabinetHeight: number,
  shelvesProps: ShelvesPropsType[],
  doorsProps: DoorPropsType[],
  drawersProps: DrawerPropsType[],
  thickness: number
) => {
  if (actualDividers.length === 0) {
    const sectionTopY = cabinetHeight / 2 - thickness
    const sectionHeight = cabinetHeight - thickness * 2

    let newShelvesProps = clone(shelvesProps)

    newShelvesProps.forEach((shProps) => {
      if (shProps.sectionNumber === 1) {
        shProps.sectionHeight = sectionHeight
        shProps.sectionY = sectionTopY - sectionHeight / 2
      }
    })

    let newDoorsProps = clone(doorsProps)

    newDoorsProps.forEach((dProps) => {
      if (dProps.sectionNumber === 1) {
        dProps.sectionHeight = sectionHeight
        dProps.sectionY = sectionTopY - sectionHeight / 2
      }
    })

    let newDrawersProps = clone(drawersProps)

    newDrawersProps.forEach((dProps) => {
      if (dProps.sectionNumber === 1) {
        dProps.sectionHeight = sectionHeight
        dProps.sectionY = sectionTopY - sectionHeight / 2
      }
    })

    return {
      shelvesProps: newShelvesProps,
      doorsProps: newDoorsProps,
      drawersProps: newDrawersProps,
    }
  }

  const sectionsProps = [] as { height: number; topY: number; number: number }[]
  const newShelvesProps = clone(shelvesProps)
  const newDoorsProps = clone(doorsProps)
  const newDrawersProps = clone(drawersProps)

  if (actualDividers.length === 1) {
    const section1TopY = cabinetHeight / 2 - thickness
    const section2TopY =
      section1TopY -
      (actualDividers[0].type === 'none'
        ? actualDividers[0].top
        : actualDividers[0].top + thickness / 2)

    const section1Height =
      actualDividers[0].type === 'none'
        ? actualDividers[0].top
        : actualDividers[0].top - thickness / 2
    const section2Height =
      cabinetHeight -
      section1Height -
      thickness * 2 -
      (actualDividers[0].type === 'none' ? 0 : thickness)

    sectionsProps.push({
      height: section1Height,
      topY: section1TopY,
      number: 1,
    })
    sectionsProps.push({
      height: section2Height,
      topY: section2TopY,
      number: 2,
    })
  } else {
    const section1TopY = cabinetHeight / 2 - thickness
    const section1Height =
      actualDividers[0].type === 'none'
        ? actualDividers[0].top
        : actualDividers[0].top - thickness / 2

    sectionsProps.push({
      height: section1Height,
      topY: section1TopY,
      number: 1,
    })

    for (let i = 1; i < actualDividers.length; i++) {
      const sectionTopY =
        section1TopY -
        (actualDividers[i - 1].type === 'none'
          ? actualDividers[i - 1].top
          : actualDividers[i - 1].top + thickness / 2)

      const sectionHeight =
        actualDividers[i].top -
        actualDividers[i - 1].top -
        (actualDividers[i].type === 'none' ? 0 : 0.5 * thickness) -
        (actualDividers[i - 1].type === 'none' ? 0 : 0.5 * thickness)

      sectionsProps.push({
        height: sectionHeight,
        topY: sectionTopY,
        number: i + 1,
      })
    }

    const lastSectionTopY =
      section1TopY -
      (actualDividers[actualDividers.length - 1].type === 'none'
        ? actualDividers[actualDividers.length - 1].top
        : actualDividers[actualDividers.length - 1].top + thickness / 2)
    const lastSectionHeight =
      cabinetHeight -
      thickness * 2 -
      (actualDividers[actualDividers.length - 1].type === 'none'
        ? actualDividers[actualDividers.length - 1].top
        : actualDividers[actualDividers.length - 1].top + thickness / 2)

    sectionsProps.push({
      height: lastSectionHeight,
      topY: lastSectionTopY,
      number: actualDividers.length + 1,
    })
  }

  for (const sProps of sectionsProps) {
    newShelvesProps.forEach((shProps) => {
      if (shProps.sectionNumber === sProps.number) {
        shProps.sectionHeight = sProps.height
        shProps.sectionY = sProps.topY - sProps.height / 2
      }
    })

    newDoorsProps.forEach((dProps) => {
      if (dProps.sectionNumber === sProps.number) {
        dProps.sectionHeight = sProps.height
        dProps.sectionY = sProps.topY - sProps.height / 2
      }
    })

    newDrawersProps.forEach((dProps) => {
      if (dProps.sectionNumber === sProps.number) {
        dProps.sectionHeight = sProps.height
        dProps.sectionY = sProps.topY - sProps.height / 2
      }
    })
  }

  return {
    shelvesProps: newShelvesProps,
    doorsProps: newDoorsProps,
    drawersProps: newDrawersProps,
  }
}

//Thunk

export const setSubsectionHeight =
  (
    sectionName: string,
    newHeight: number,
    prevHeight: number,
    locks: SectionLock[]
  ): ThunkType =>
  async (dispatch: typeof store.dispatch, getState) => {
    if (
      !(
        locks.filter((lock) => lock.isLock === true).length ===
        locks.length - 1
      )
    ) {
      //!(If only this section is non-locked)

      const state = getState()

      const cabProps = !state.cabinetReducer.isCorner
        ? state.cabinetReducer.props
        : state.cabinetReducer.cornerProps
      // const minMargin = 5

      let dividersProps = clone(cabProps.sectionProps.dividersProps).sort(
        (a, b) => a.top - b.top
      )
      let prevDividers = clone(dividersProps)

      const sectionNumber = parseInt(sectionName.split('_')[1])

      if (locks[sectionNumber - 1].isLock)
        //If section that must be changed is locked
        return

      let deltaHeight = newHeight - prevHeight
      let deltaHeightForSections =
        (-1 * deltaHeight) /
        (locks.filter((lock) => lock.isLock === false).length - 1)

      if (sectionNumber === 1) {
        dividersProps[0].top += deltaHeight

        for (let i = 1; i < locks.length - 1; i++) {
          if (locks[i].isLock) {
            dividersProps[i].top =
              dividersProps[i - 1].top +
              (prevDividers[i].top - prevDividers[i - 1].top)
          } else {
            dividersProps[i].top =
              dividersProps[i - 1].top +
              (prevDividers[i].top - prevDividers[i - 1].top) +
              deltaHeightForSections
          }
        }
      } else {
        if (!locks[0].isLock) {
          dividersProps[0].top += deltaHeightForSections
        }

        for (let i = 1; i < locks.length - 1; i++) {
          if (sectionNumber === locks[i].number) {
            dividersProps[i].top =
              dividersProps[i - 1].top +
              (prevDividers[i].top - prevDividers[i - 1].top) +
              deltaHeight
          } else {
            if (locks[i].isLock) {
              dividersProps[i].top =
                dividersProps[i - 1].top +
                (prevDividers[i].top - prevDividers[i - 1].top)
            } else {
              dividersProps[i].top =
                dividersProps[i - 1].top +
                (prevDividers[i].top - prevDividers[i - 1].top) +
                deltaHeightForSections
            }
          }
        }
      }

      // console.log(dividersProps)

      const newProps = recalculateAllShelvesAndDoorsPositions(
        // prevDividers,
        dividersProps,
        cabProps.height,
        cabProps.sectionProps.shelvesProps,
        cabProps.sectionProps.doorsProps,
        cabProps.sectionProps.drawersProps,
        getState().appReducer.configs.thickness
      )

      dispatch(actions.setDividers(dividersProps))
      dispatch(
        actions.setDoors(newProps.doorsProps, 'setSubSection from cabRed')
      )
      dispatch(actions.setDrawers(newProps.drawersProps))
      dispatch(actions.setShelves(newProps.shelvesProps))
    }
  }

export const setCabinetSizes =
  (width: number, height: number, depth: number): ThunkType =>
  async (dispatch: typeof store.dispatch, getState) => {
    const thickness = getState().appReducer.configs.thickness

    dispatch(actions.setWidth(width, thickness))
    dispatch(actions.setHeight(height, thickness, true))
    dispatch(actions.setDepth(depth))
  }

export type ActionsType = InferActionsType<typeof actions>
type ThunkType = ThunkAction<Promise<void>, StateType, unknown, ActionsType>

export default cabinetReducer
